<template>
    <div class="v-view chart-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
        <div class="v-title">{{ title }}</div>
        <div class="statistic-content">

            <div class="statistic-content-item" v-for="(value, key) in elderData" :key="key">
                <template v-if="!value.none">
                    <img :src="value.img" alt="">
                    <p>{{ value.name }}</p>
                    <p>
                        {{ value.value }}
                        <span class="unit">位</span>
                    </p>
                </template>
            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    name: 'ElderlyDataStatistics',
    computed: {},
    props: {
        type: {
            type: String,
            default: 'pie',
        },
        span: {
            type: Number,
            default: 1,
        },
        title: {
            type: String,
            default: '老人数据统计',
        },
    },
    watch: {},
    data() {
        // const img = require(this.$configer.elderData)
        return {
            elderData: this.$configer.elderData
        }
    },
    created() {
    },
    beforeDestroy() { },
    methods: {},
}
</script>
  